import { Component } from '@angular/core';
import { smoothlyMenu } from '../../../app.helpers';
import { Router } from '@angular/router';
declare var jQuery:any;

@Component({
    selector: 'topnavbar',
    templateUrl: 'topnavbar.template.html'
})
export class TopnavbarComponent {
    
    title = "";
    /*ngOnInit() {
        this.hero$ = this.route.paramMap
          .switchMap((params: ParamMap) =>
            this.service.getHero(params.get('id')));
      } CUANDO RECIBO PARAMETROS
      */

    cerrarSesion(){
        
        localStorage.removeItem('currentUser');
        localStorage.removeItem('user');
        this.router.navigate(['login']);
        
    }

    constructor(private router: Router) {

        this.router.events.subscribe((path) => {
            //alert(window.location.pathname);
            if ('/empresas' == window.location.pathname) {
                this.title = "Gestionar Empresas";
            }
            if ('/conductores' == window.location.pathname) {
                this.title = "Gestionar Conductores";
            }
            if ('/vehiculos' == window.location.pathname) {
                this.title = "Gestionar Vehiculos";
            }
            if ('/recargas/historial' == window.location.pathname) {
                this.title = "Historial de recargas";
            }
            if ('/mainView' == window.location.pathname) {
                this.title = 'Inicio';
            }

            if ('/clientes' == window.location.pathname) {
                this.title = 'Gestión de clientes';
            }

            if ('/recargaReporte' == window.location.pathname) {
                this.title = 'Reporte de Recargas por fecha';
            }

            if ('/usuarios' == window.location.pathname) {
                this.title = 'Gestionar Usuarios';
            }

            if ('/servicioReporte' == window.location.pathname) {
                this.title = 'Reporte de Servicios por Empresa';
            }

            if ('/geolocalizacion' == window.location.pathname) {
                this.title = 'Pedir Servicios';
            }
        });
    }

    toggleNavigation(): void {
        jQuery("body").toggleClass("mini-navbar");
        smoothlyMenu();
    }

}



// WEBPACK FOOTER //
// ./src/app/components/common/topnavbar/topnavbar.component.ts